import { Component, Input, OnInit } from '@angular/core';

import { MatTableDataSource } from '@angular/material/table';
import { InvoiceStatus, MSPInvoiceInterface } from '@contracts/interfaces/invoice.interface';
import { LineItem } from '@contracts/interfaces/lineitem.interface';
import { InvoiceComponent } from '../invoice';

@Component({
  selector: 'app-invoice-msp',
  templateUrl: './invoice-msp.component.html',
  styleUrls: ['./invoice-msp.component.scss', '../../pages/invoice-table.scss']
})
export class InvoiceMSPComponent extends InvoiceComponent implements OnInit {
  public MCRItemsDataSource: MatTableDataSource<LineItem>;
  public ServiceItemsDataSource: MatTableDataSource<LineItem>;

  public MCRSubTotal = 0;
  public ServiceSubTotal = 0;

  @Input() 
  public invoice: MSPInvoiceInterface;

  public defaultInvoice = {
    type: "msp",
    status: InvoiceStatus.Unpaid,
    customer: null,
    number: null,
    custom: "",
    dateCreated: new Date(),
    dateDue: new Date(),
    subTotal: 0,
    total: 0,
    paymentsMade: [],
    pdf: {
        file: "invoice-msp"
    },
    MCRLineItems: [
        {
            item: '',
            desc: '',
            qty: 1,
            price: 0
        }
    ],
    serviceLineItems: [
        {
            item: '',
            desc: '',
            qty: 1,
            price: 0
        }
    ],
    gst: 0,
    isGSTIncluded: true,
    communicationLog: [],
    lineItems: []
  }

  reloadInvoiceTables() {
    
    if (this.invoice.MCRLineItems == undefined) {
      this.invoice.MCRLineItems = [];
    }

    if (this.invoice.MCRLineItems.length == 0) {
      this.invoice.MCRLineItems.push({
        item: "",
        desc: "",
        price: 0,
        qty: 1,
      })
    }

    if (this.invoice.serviceLineItems == undefined) {
      this.invoice.serviceLineItems = [];
    }

    if (this.invoice.serviceLineItems.length == 0) {
        this.invoice.serviceLineItems.push({
            item: "",
            desc: "",
            price: 0,
            qty: 1,
        })
    }

    this.calculateTotal();

    this.MCRItemsDataSource = new MatTableDataSource(this.invoice.MCRLineItems);
    this.MCRItemsDataSource._updateChangeSubscription();

    this.ServiceItemsDataSource = new MatTableDataSource(this.invoice.serviceLineItems);
    this.ServiceItemsDataSource._updateChangeSubscription();
  }


  calculateTotal() {
    // Calculate Total
    this.invoice.total = 0;
    this.MCRSubTotal = 0;
    this.ServiceSubTotal = 0;
    this.invoice.lineItems = [];
    
    for (let i=0; i < this.invoice.MCRLineItems.length;i++) {
      this.invoice.lineItems.push(this.invoice.MCRLineItems[i]);
      this.MCRSubTotal += this.invoice.MCRLineItems[i].price * this.invoice.MCRLineItems[i].qty
    }

    for (let i=0; i < this.invoice.serviceLineItems.length;i++) {
      this.invoice.lineItems.push(this.invoice.serviceLineItems[i]);
      this.ServiceSubTotal += this.invoice.serviceLineItems[i].price * this.invoice.serviceLineItems[i].qty;
    }
    
    // Work around for
    // NG0100 Expression has changed after it was checked
    setTimeout(() => {
      this.invoice = this.invoicesService.validate(this.invoice);
    },0)

  }

  addMCRLineItem() {

    this.invoice.MCRLineItems.push({
      item: "",
      desc: "",
      qty: 1,
      price: 0
    });

    this.reloadInvoiceTables();
  }

  addServiceLineItems() {

    this.invoice.serviceLineItems.push({
      item: "",
      desc: "",
      qty: 1,
      price: 0
    });

    this.reloadInvoiceTables();
  }

  save() {
    this.reloadInvoiceTables();
    super.save();
  }

  check() {
    this.reloadInvoiceTables();
    console.log(this.invoice);
    this.calculateTotal();
  }

  deleteLineItemMRC(index) {
    this.invoice.MCRLineItems.splice(index, 1);
    this.reloadInvoiceTables();
  }

  deleteLineItemService(index) {
    this.invoice.serviceLineItems.splice(index, 1);
    this.reloadInvoiceTables();
  }
}
